import { TrustpilotReviewCard } from "components/TrustpilotReviewCard";
import type { TrustpilotReviewAdapterProps } from "./TrustpilotReviewCard.d";

const TrustpilotReviewAdapter = ({
  blok: { reviewText, author, authorsCountry, rating, avatarSrc },
}: TrustpilotReviewAdapterProps) => (
  <TrustpilotReviewCard
    reviewText={reviewText}
    author={author}
    authorsCountry={authorsCountry}
    rating={rating}
    avatarSrc={avatarSrc}
  />
);

export default TrustpilotReviewAdapter;
